<template>
<header>
    <nav class="main-nav-one stricky original" id="original-fix">
        <div class="container">
            <div class="inner-container">
                <div class="logo-box">
                    <a href="/">
                        <img src="/assets/images/logo-1-1.png" alt="">
                    </a>
                    <a href="#" class="side-menu__toggler"><i class="fa fa-bars"></i></a>
                </div>
                <!-- /.logo-box -->
                <div class="main-nav__main-navigation">
                    <ul class="main-nav__navigation-box">
                        <li :class="{'current':pathType==='home'}">
                            <a href="/">ホーム</a>
                        </li>
                        <li :class="{'current':pathType==='about'}">
                            <a href="/about">会社情報</a>
                        </li>
                        <li :class="{'current':pathType==='business'}">
                            <a href="/business">事業内容</a>
                        </li>
                        <li :class="{'current':pathType==='services'}">
                            <a href="/service">サービス</a>
                        </li>
                        <li :class="{'current':pathType==='news'}">
                            <a href="/news">お知らせ</a>
                        </li>
                        <li :class="{'current':pathType==='access'}">
                            <a href="/access">アクセス</a>
                        </li>
                        <li :class="{'current':pathType==='recruit'}">
                            <a href="/recruit">採用情報</a>
                        </li>
                    </ul>
                    <!-- /.main-nav__navigation-box -->
                </div>
                <!-- /.main-nav__main-navigation -->
                <div class="main-nav__right">
                    <a href="/contact" class="thm-btn main-nav-one__btn"><span>お問い合わせ</span></a>
                    <!-- /.thm-btn main-nav-one__btn -->
                </div>
                <!-- /.main-nav__right -->
            </div>
            <!-- /.inner-container -->
        </div>
        <!-- /.container-fluid -->
    </nav>
</header>
</template>

<script>
import { onMounted,ref,watch } from '@vue/runtime-core'
import { useRoute} from "vue-router"
export default {
  name: "Header",
  setup() { 
    const route = useRoute();
    const pathType = ref('')
    watch(
      () => route.meta.pathType,
      newPathType => {
        pathType.value = newPathType;
      }
    )
    onMounted(()=>{
      pathType.value = route.meta.pathType;
    })
    return {pathType}
  }
}
</script>